import { ModuleAndIdMapping, Modules } from "../../../constants/DatabaseConstants/MasterConstant";
import ConfigMaster from "../ModalComponents/ConfigMaster";
import RoleMaster from "../ModalComponents/RoleMaster";
import UserRoleAllocationMaster from "../ModalComponents/UserRoleAllocationMaster";
import CustomerMaster from "../ModalComponents/CustomerMaster";
import CustomerLocationMaster from "../ModalComponents/CustomerLocationMaster";
import CustomerClientMaster from "../ModalComponents/CustomerClientMaster";
import LocationTypeMaster from "../ModalComponents/LocationTypeMaster";
import ParkingMapTypeMaster from "../ModalComponents/SiteMapTypeMaster";
import KeyFobMaster from "../ModalComponents/KeyFobMaster";
import KeyFobAllocationMaster from "../ModalComponents/KeyFobAllocationMaster";
import VehicleTypeMaster from "../ModalComponents/VehicleTypeMaster";
import PriceManagement from "../ModalComponents/PricingMaster";
import FaqMaster from "../ModalComponents/FaqMaster";
import NotificationMaster from "../ModalComponents/NotificationMaster";
import { useAddEditMaster } from "./index.hook";
import { AddEditMasterProps } from "../../../shared/interface/MasterManagement/masterManagementCommon.interface";
import AdvanceBookingQuotaMaster from "../ModalComponents/AdvanceBookingQuotaMaster";

/* controller component for saving data to DB. */
const AddEditMaster = (props: AddEditMasterProps) => {
  const config = useAddEditMaster(props);
  const { moduleId, addRecord, handleAddRecord, rowData, handleClearRowIdAndActionType, handleBulkEditRecord, bulkEditRecord } = props;

  /* Module with component map */
  const moduleComponentMap = {
    [ModuleAndIdMapping[Modules.CONFIG_MASTER]]: ConfigMaster,
    [ModuleAndIdMapping[Modules.ROLE_MASTER]]: RoleMaster,
    [ModuleAndIdMapping[Modules.USER_ROLE_MASTER]]: UserRoleAllocationMaster,
    [ModuleAndIdMapping[Modules.CUSTOMER_MASTER]]: CustomerMaster,
    [ModuleAndIdMapping[Modules.CUSTOMER_LOCATION_MASTER]]: CustomerLocationMaster,
    [ModuleAndIdMapping[Modules.CUSTOMER_CLIENT_MASTER]]: CustomerClientMaster,
    [ModuleAndIdMapping[Modules.LOCATION_TYPE_MASTER]]: LocationTypeMaster,
    [ModuleAndIdMapping[Modules.PARKING_MAP_TYPE_MASTER]]: ParkingMapTypeMaster,
    [ModuleAndIdMapping[Modules.KEY_FOB_MASTER]]: KeyFobMaster,
    [ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER]]: KeyFobAllocationMaster,
    [ModuleAndIdMapping[Modules.VEHICLE_TYPE_MASTER]]: VehicleTypeMaster,
    [ModuleAndIdMapping[Modules.PRICING_MASTER]]: PriceManagement,
    [ModuleAndIdMapping[Modules.FAQ_MASTER]]: FaqMaster,
    [ModuleAndIdMapping[Modules.NOTIFICATION_MASTER]]: NotificationMaster,
    [ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER]]: AdvanceBookingQuotaMaster
  };

  const MasterComponent = moduleComponentMap[moduleId];

  return MasterComponent ? <MasterComponent saving={config.saving} handleSubmit={config.handleSubmit} addRecord={addRecord} handleAddRecord={handleAddRecord} rowData={rowData} handleClearRowIdAndActionType={handleClearRowIdAndActionType} handleBulkEditRecord={handleBulkEditRecord} bulkEditRecord={bulkEditRecord} /> : null;
};

export default AddEditMaster;
